import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router";
import { Card, Table, Tooltip } from "antd";
import { toClaimNumberString, toFilingS3Link } from "../../../helpers/converters";
import { sorterNumberGen, sorterStringGen } from "../../../helpers/table";
import UserAccess from "../../../components/common/user-access";
import reactStringReplace from "react-string-replace";

const toReferenceTypeString = t => {
  switch (t) {
    case "pat-us":
      return "US Patent";
    case "pat-foreign":
      return "Foreign Patent";
    case "app-us":
      return "US Publication";
    case "app-foreign":
      return "Foreign Publication";
    default:
      return "NPL";
  }
};

const ClaimFindingsTable = props => {
  const tableHeaders = [
    {
      dataIndex: "docket_number",
      key: "docket_number",
      title: "Paper No.",
      sorter: sorterNumberGen("docket_number"),
      width: 100,
      render: toFilingS3Link
    },
    {
      dataIndex: "filing_type",
      key: "filing_type",
      title: "Type",
      sorter: sorterStringGen("filing_type"),
      width: 200
    },
    {
      dataIndex: "outcome",
      key: "outcome",
      title: "Outcome",
      sorter: sorterStringGen("outcome"),
      width: 140
    },
    {
      dataIndex: "statute",
      key: "statute",
      title: "Statute",
      sorter: sorterNumberGen("statute"),
      width: 140
    },
    {
      dataIndex: "reference",
      key: "reference",
      title: "Reference",
      width: 200,
      render: (val, record) => {
        const refMap = props.referenceMappings[record.docket_number];
        if (refMap && refMap.length > 0) {
          let valNew = val;
          refMap.forEach(m => {
            valNew = reactStringReplace(valNew, m.key, (match, i) => {
              const { type: t, resource } = m;
              const r = resource.trim();
              return (
                <Tooltip title={`${toReferenceTypeString(t)} ${r}`} key={match + i}>
                  {t === "pat-us" && r.match(/^\d{6,8}$/) ? <Link to={`/patents/patent/${r}`}>{match}</Link> : match}
                </Tooltip>
              );
            });
          });
          return valNew;
        }
        return val;
      }
    },
    {
      dataIndex: "claim_numbers",
      key: "claim_numbers",
      title: "Claims",
      width: 400,
      render: toClaimNumberString
    }
  ];
  const tableScroll = {
    x: 1500,
    y: 300
  };
  return props.data && props.data.length > 0 ? (
    <Card title="Grounds Asserted">
      <UserAccess isPublicSignupAllowed={true} showHelp={true}>
        <Table columns={tableHeaders} dataSource={props.data} loading={props.loading} pagination={false} scroll={tableScroll} size="small" />
      </UserAccess>
    </Card>
  ) : null;
};
ClaimFindingsTable.propTypes = {
  data: PropTypes.array,
  referenceMappings: PropTypes.object,
  loading: PropTypes.bool
};
ClaimFindingsTable.defaultProps = {
  data: [],
  referenceMappings: {},
  loading: false
};

export default ClaimFindingsTable;
